module.exports = __webpack_public_path__ + "img/list_6_zh.d5012121.png";